(function () {
  const cr_open = document.querySelectorAll(".menu__toggle"),
    cr_close = document.querySelector(".menu__close"),
    cr_body = document.querySelector("body");

  function toggleMenu() {
    cr_body.classList.toggle("openned");
      setTimeout(() => cr_body.classList.toggle("open"), 200);
  }

  cr_open && cr_open.forEach(element => {
    element.addEventListener("click", toggleMenu);
  });
  cr_close && cr_close.addEventListener("click", toggleMenu);
})();
